// #region installment fee manipulation methods

const resolveInstallmentFeeManualPayment = (cart) => {
  const paymentMethod =
    cart?.attributes?._paymentMethod ||
    window.cartDataForPaymentSelectionInCart?.attributes?._paymentMethod ||
    window.cartAvailablePaymentMethods?.subscription?.[0] ||
    'Online';

  return !!(window.KROWN?.settings?.manualPaymentTypes?.includes(paymentMethod));
};

// Build the installment-fee cart line item from the values stashed in
// localStorage by theme.liquid. Pure — no network — so callers can batch the
// fee into the same /cart/add.js request as the product instead of chaining a
// separate add. Returns null when no installment fee is configured.
const buildInstallmentFeeItem = (isManualPayment) => {
  const installmentFeeVariantId = localStorage.getItem('installmentFeeVariantId');
  const installmentFeeVariantSellingPlanId = localStorage.getItem('installmentFeeVariantSellingPlanId');
  const installmentMetafieldValue = localStorage.getItem('installmentMetafieldValue');
  const installmentFeeGlobalId = String(localStorage.getItem('installmentFeeGlobalId') || '').trim();

  if (!installmentFeeVariantId || !installmentFeeVariantSellingPlanId) {
    return null;
  }

  const item = {
    id: installmentFeeVariantId,
    quantity: 1,
    selling_plan: isManualPayment ? '' : installmentFeeVariantSellingPlanId,
    properties: {}
  };

  if (installmentMetafieldValue) {
    item.properties["_monthly_base_total"] = installmentMetafieldValue;
  }

  if (isManualPayment) {
    item.properties["_sellingplan"] = installmentFeeVariantSellingPlanId;
  }

  if (typeof window.mergeCartLinePropertiesWithGlobalId === 'function') {
    item.properties = window.mergeCartLinePropertiesWithGlobalId(
      installmentFeeVariantId,
      item.properties
    );
  }
  if (!item.properties._globalId && installmentFeeGlobalId) {
    item.properties._globalId = installmentFeeGlobalId;
  }

  return item;
};

const postInstallmentFeeItem = async (isManualPayment) => {
  const item = buildInstallmentFeeItem(isManualPayment);
  if (!item) {
    return false;
  }

  if (typeof window.awaitSharedCartRestore === 'function') {
    await window.awaitSharedCartRestore();
  }

  const response = await fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ items: [item] })
  }).catch((error) => {
    console.error(error);
    return null;
  });

  return !!(response && response.ok);
};

const addInstallmentFee = async (isManualPayment) => {
  // remove before adding so that quantity is always 1
  await removeInstallmentFee();
  await postInstallmentFeeItem(isManualPayment);
};

const removeInstallmentFee = async () => {
  const installmentFeeVariantId = localStorage.getItem('installmentFeeVariantId');

  if (!installmentFeeVariantId) {
    return;
  }

  if (typeof window.awaitSharedCartRestore === 'function') {
    await window.awaitSharedCartRestore();
  }

  const updates = {};
  updates['' + installmentFeeVariantId] = 0;

  await fetch(`${KROWN.settings.routes.cart_update_url}.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  }).then((cartResponse) => 
  {
    if (!cartResponse.ok) {
      console.error('Failed to fetch the updated cart');
    }
     fetch('/cart', {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/javascript",
            },
        }).then((response) => {
            if (!response.ok) {
              console.log('Network response was not ok');
            }
            return response.json();
          })
          .then((data) => {
            if(data.items.length==0){
              $(".countries_list_modal-content").attr('data-cart-empty',"true");
            }
            else{
                  $(".countries_list_modal-content").attr('data-cart-empty',"false");
                }
          })
          .catch((error) => {
            console.error('There was a problem with the fetch operation:', error);
          });
    
  }).catch((error) => {
    console.error(error);
  });
};

// #endregion
 
// #region PDP

const createCustomAddToCartBtnInPDP = () => {
  // remove before adding to account for variant change
  document.querySelector('.custom-add-to-cart')?.remove();

  const addToCartBtn = document.querySelector('[data-js-product-add-to-cart]');
  const form = addToCartBtn.closest('.flex-buttons');

  addToCartBtn.classList.add('display-none');

  const addBtn = document.createElement('button');
  const addBtnText = document.createElement('span');
  const addBtnLoaderContainer = document.createElement('span');
  const addBtnLoader = document.createElement('div');

  addBtn.setAttribute('type', 'button');
  addBtn.addEventListener("click", addProductWithInstallmentFeeInPDP);
  addBtn.classList.add('custom-add-to-cart', 'add-to-cart', 'button', 'button--solid', 'position-relative');
  addBtnText.classList.add('button__text');
  addBtnLoaderContainer.classList.add('button-loader-container', 'visibility-hidden');
  addBtnLoader.classList.add('button-loader');

  addBtnText.innerText = addToCartBtn.innerText.trim();

  if (addBtnText.innerText.toLowerCase() === KROWN.settings.locales.products_sold_out_variant.toLowerCase()) {
    addBtn.classList.add('disabled');
  }

  addBtnLoaderContainer.append(addBtnLoader);
  addBtn.append(addBtnText);
  addBtn.append(addBtnLoaderContainer);

  form.insertBefore(addBtn, addToCartBtn);
};

const addProductWithInstallmentFeeInPDP = async (event) => {
  const addBtn = event.currentTarget;
  const addToCartBtn = document.querySelector('[data-js-product-add-to-cart]');

  const purchaseTypeInputs = addBtn
    .closest('.product-text')
    .querySelector('.purchase_type_radio')
    ?.querySelectorAll('input[type="radio"]');
  const selectedPurchaseType = Array.from(purchaseTypeInputs || []).find((input) => input?.checked)?.value;

  // Get payment type - check for radio buttons first (new implementation), then fallback to select (old implementation)
  const subscriptionPaymentTypeContainer = addBtn
    .closest('.product-text')
    ?.querySelector('.subscription-payment-type');
  
  let selectedPaymentType = null;
  
  if (subscriptionPaymentTypeContainer) {
    // Check for radio buttons (new implementation)
    const paymentTypeRadios = subscriptionPaymentTypeContainer.querySelectorAll('input[type="radio"].product-payment-type-radio');
    if (paymentTypeRadios.length > 0) {
      const selectedRadio = Array.from(paymentTypeRadios).find((radio) => radio.checked);
      selectedPaymentType = selectedRadio?.dataset.paymentType || null;
    } else {
      // Fallback to select element (old implementation)
      const paymentTypeOptions = subscriptionPaymentTypeContainer.querySelectorAll('option');
      const selectedOption = Array.from(paymentTypeOptions).find((option) => option.selected);
      selectedPaymentType = selectedOption?.dataset.paymentType || null;
    }
  }
  const selectedPaymentMethod = window.cartDataForPaymentSelectionInCart?.attributes?._paymentMethod
    || (selectedPurchaseType === 'subscription' ? window.cartAvailablePaymentMethods?.subscription[0] : window.cartAvailablePaymentMethods?.one_time[0]);
  const isManualPayment = KROWN.settings.manualPaymentTypes.includes(selectedPaymentMethod);

  addBtn.classList.add('no-click');
  addBtn.querySelector('.button__text').classList.add('visibility-hidden');
  addBtn.querySelector('.button-loader-container').classList.remove('visibility-hidden');

  if (selectedPurchaseType === 'subscription' && selectedPaymentType === 'installment') {
    await addInstallmentFee(isManualPayment);
  }

  addToCartBtn.click();
};

// #endregion

if (typeof window !== 'undefined') {
  window.addInstallmentFee = addInstallmentFee;
  window.removeInstallmentFee = removeInstallmentFee;
  window.buildInstallmentFeeItem = buildInstallmentFeeItem;
  window.postInstallmentFeeItem = postInstallmentFeeItem;
  window.resolveInstallmentFeeManualPayment = resolveInstallmentFeeManualPayment;
}
